<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <router-view  :language="language" @selectLanguageEv="selectLang" />
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  setup() {
    const { contentWidth } = useAppConfig()
    return { contentWidth }
  },
   data() {
      return {
        language: 'en',
        
      }
    },
    methods: {
      selectLang(lang) {
        this.language = lang
      }
    }
}
</script>
